<template>
  <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      data-vv-scope="storeTrain"
      @submit.prevent="validateBeforeSubmit('storeTrain')"
  >
    <v-layout row wrap>
      <v-flex xs12 md6>
        <label for="number">Number</label>
        <v-text-field
            solo flat
            type="text"
            name="number"
            v-model="train.number"
            label="Train Number"
            browser-autocomplete=off
            v-validate="'required'"
            :error-messages="errors.collect('storeTrain.number')"
            :disabled="!!trainNumber"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="name">Name</label>
        <v-text-field
            solo flat
            type="text"
            name="name"
            v-model="train.name"
            label="Name"
            browser-autocomplete=off
            v-validate="'required'"
            :error-messages="errors.collect('storeTrain.name')"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="name_mr">Name Mr</label>
        <v-text-field
            solo flat
            type="text"
            name="name_mr"
            v-model="train.name_mr"
            label="Name Mr"
            browser-autocomplete=off
            v-validate="'required'"
            :error-messages="errors.collect('storeTrain.name_mr')"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="name_hi">Name Hi</label>
        <v-text-field
            solo flat
            type="text"
            name="name_hi"
            v-model="train.name_hi"
            label="Name Hi"
            browser-autocomplete=off
            v-validate="'required'"
            :error-messages="errors.collect('storeTrain.name_hi')"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="code">Short Code</label>
        <v-text-field
            solo flat
            type="text"
            name="code"
            v-model="train.short_code"
            label="Short Code"
            browser-autocomplete=off
            :error-messages="errors.collect('storeTrain.code')"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="exception_day_id">Exception Day</label>
        <v-autocomplete
            solo flat
            v-model="train.exception_day_id"
            :items="exceptionDays"
            item-text="name"
            item-value="id"
            label="Exception Day"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <label for="speed">Speed</label>
        <v-autocomplete
            solo flat
            v-model="train.speed"
            :items="speeds"
            label="Speed"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <label for="coaches">Coaches</label>
        <v-text-field
            solo flat
            type="number"
            name="coaches"
            v-model="train.coaches"
            label="Coaches"
            v-validate="'required'"
            :error-messages="errors.collect('storeTrain.coaches')"
            min="1"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="first_station_id">First Station</label>
        <v-autocomplete
            solo flat
            v-model="train.first_station_id"
            :loading="loading.firstStation"
            :items="firstStations"
            :search-input.sync="search.firstStation"
            cache-items
            hide-no-data
            item-text="name"
            item-value="id"
            label="First Station"
            v-validate="'required'"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <label for="last_station_id">Last Station</label>
        <v-autocomplete
            solo flat
            v-model="train.last_station_id"
            :loading="loading.lastStation"
            :items="lastStations"
            :search-input.sync="search.lastStation"
            cache-items
            hide-no-data
            item-text="name"
            item-value="id"
            label="Last Station"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <label for="line_id">Line</label>
        <v-autocomplete
            solo flat
            v-model="train.line_id"
            :loading="loading.lines"
            :items="lines"
            item-text="name"
            item-value="id"
            label="Line"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <label for="properties">Properties</label>
        <v-autocomplete
            solo flat
            multiple
            v-model="train.properties"
            :loading="loading.properties"
            :items="properties"
            item-text="name"
            item-value="id"
            label="Properties"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <label for="rake_link_code">Rake Link Code</label>
        <v-text-field
          solo flat
          type="text"
          name="rake_link_code"
          v-model="train.rake_link_code"
          label="Rake Link Code"
          browser-autocomplete=off
          v-validate="'required'"
          :error-messages="errors.collect('storeTrain.rake_link_code')"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <label for="rake_link_order_no">Rake Link Order No</label>
        <v-text-field
            solo flat
            type="number"
            name="rake_link_order_no"
            v-model="train.rake_link_order_no"
            label="Rake Link Order No"
            v-validate="'required'"
            :error-messages="errors.collect('storeTrain.rake_link_order_no')"
            min="1"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-switch v-model="train.gps_enabled" value="1" label="Is GPS Enabled?" false-value="0" true-value="1"
                  :value-comparator="() => train.gps_enabled == 1"
        ></v-switch>
      </v-flex>
      <v-flex cols="12">
        <v-layout justify-end>
          <v-btn type="submit"
                 :disabled="!valid || loading.submit"
                 color="primary"
                 :loading="loading.submit"
          >
            Submit
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: "TrainForm",
  props: {
    trainNumber: {
      type: String,
      required: false
    },
  },
  watch: {
    'search.firstStation': async function (val) {
      if (val) {
        this.firstStations = await this.getStationsList(val)
      }
    },
    'search.lastStation': async function (val) {
      if (val) {
        this.lastStations = await this.getStationsList(val)
      }
    }
  },
  methods: {
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    storeTrain() {
      this.loading.submit = true
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/local-trains`, this.train,
          { headers: this.$headers })
          .then((response) => {
            if (response.data.status == 1) {
              this.$emit('success')
            }
          })
          .finally(() => {
            this.loading.submit = false
          })
    },
    getTrainInfo(id) {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/local-trains/` + id, { headers: this.$headers })
        .then(async (response) => {
          if (response.data.status == 1) {
            this.train = response.data.data

            this.train.line_id = this.train.line_id ? parseInt(this.train.line_id) : null
            
            this.train.properties = this.train.properties.map((property) => parseInt(property.id))
            this.train.exception_day_id =
              this.train.exception_day_id === null ? 0 : this.train.exception_day_id

            const stations = response.data.stations || []

            this.firstStations = stations
            this.lastStations = stations

            if (this.train.first_station_id && !stations.find(s => s.id == this.train.first_station_id)) {
              this.firstStations.push({ id: this.train.first_station_id, name: 'Selected Station' })
            }

            if (this.train.last_station_id && !stations.find(s => s.id == this.train.last_station_id)) {
              this.lastStations.push({ id: this.train.last_station_id, name: 'Selected Station' })
            }
          }
        })
    },
    getStationsList(search, id = null) {
      return new Promise((resolve) => {
        axios.get(`${process.env.VUE_APP_API_URL}/api/v1/stations/search?search=${search}${id ? `&id=${id}` : ''}`, { headers: this.$headers })
            .then((response) => {
              if (response.data.status == 1) {
                resolve(response.data.data)
              }
            })
      })
    },
    getLinesList() {
      this.loading.lines = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/lines`,{ headers: this.$headers })
          .then((response) => {
            if (response.data.status == 1) {
              this.lines = response.data.data
            }
          })
          .finally(() => {
            this.loading.lines = false
          })
    },
    getExceptionDaysList() {
      this.loading.exceptionDays = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/exception_days`, { headers: this.$headers })
        .then((response) => {
          if (response.data.status == 1) {
            this.exceptionDays = response.data.data

            this.exceptionDays.unshift({
              name: "No Exception",
              marking: "X",
              id: 0
            })
          }
        })
        .finally(() => {
          this.loading.exceptionDays = false
        })
    },
    getPropertiesList() {
      this.loading.properties = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-properties`,{ headers: this.$headers })
          .then((response) => {
            if (response.data.status == 1) {
              this.properties = response.data.data
            }
          })
          .finally(() => {
            this.loading.properties = false
          })
    },
  },
  mounted() {
    if (this.trainNumber) {
      this.getTrainInfo(this.trainNumber)
    }
    this.getLinesList()
    this.getExceptionDaysList()
    this.getPropertiesList()
  },
  data: function () {
    return {
      valid: false,
      search: {
        firstStation: '',
        lastStation: '',
      },
      properties: [],
      exceptionDays: [],
      lines: [],
      firstStations: [],
      lastStations: [],
      speeds: ['S', 'F'],
      loading: {
        exceptionDays: false,
        firstStation: false,
        lines: false,
        lastStation: false,
        trainInfo: false,
        submit: false,
        properties: false
      },
      train: {
        number: '',
        name: '',
        short_code: '',
        exception_day_id: null,
        speed: 'S',
        coaches: '',
        line_id: null,
        first_station_id: '',
        last_station_id: '',
        gps_enabled: 0,
        properties: []
      }
    }
  }
}
</script>
